﻿(function () {
    var PasswordToggler = function (element, field, showLabelClass) {
        this.element = element;
        this.field = field;
        this.showLabelClass = showLabelClass;
        this.toggle();
    };

    PasswordToggler.prototype = {
        toggle: function () {
            var self = this;            
            if (self.element) {                
                self.element.addEventListener("change",
                    function () {
                        if (self.element.checked) {
                            self.field.setAttribute("type", "text");
                            $(self.showLabelClass).addClass('hide-icon').removeClass('show-icon');
                        } else {
                            self.field.setAttribute("type", "password");
                            $(self.showLabelClass).addClass('show-icon').removeClass('hide-icon');
                        }
                    },
                    false);
            }            
        }
    };

    document.addEventListener("DOMContentLoaded", function () {
        var checkbox = document.querySelector("#acc-show-hide"),
            pwd = document.querySelector("#accPassword2");
        var toggler = new PasswordToggler(checkbox, pwd, ".acc-show-label");

        var checkbox2 = document.querySelector("#acc-show-hide2"),
            pwd2 = document.querySelector("#accPassword");
        var toggler2 = new PasswordToggler(checkbox2, pwd2, ".acc-show-label2");

        var quickPasswordCheckbox = document.querySelector("#quick-show-hide"),
        quickPasswordInput = document.querySelector("#quick-pwd");
        var quickPasswordToggler = new PasswordToggler(quickPasswordCheckbox, quickPasswordInput, ".quick-show-label");
    });
})();